import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

export const EditSettingsDialog = ({ target, onClose, onSaved }) => {
  const [vals, setVals] = useState({ name: "", report_title: "", report_filename: "" });
  useEffect(() => {
    if (target) setVals({ name: target.name || "", report_title: target.report_title || "", report_filename: target.report_filename || "" });
  }, [target]);

  const save = async () => {
    if (!vals.name.trim()) return toast.error("Project name is required");
    try {
      await api.put(`/projects/${target.id}`, {
        name: vals.name.trim(), report_title: vals.report_title.trim(),
        report_filename: vals.report_filename.trim() });
      toast.success("Settings updated");
      onClose();
      onSaved();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="edit-settings-dialog">
        <DialogHeader><DialogTitle className="font-display">Edit settings - {target?.name}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Project name</Label>
            <Input value={vals.name} onChange={(e) => setVals({ ...vals, name: e.target.value })} className="mt-1" data-testid="es-name" /></div>
          <div><Label>Report cover title <span className="text-muted-foreground font-normal">(optional)</span></Label>
            <Input value={vals.report_title} onChange={(e) => setVals({ ...vals, report_title: e.target.value })} className="mt-1" placeholder="Defaults to client / project name" data-testid="es-title" /></div>
          <div><Label>Report filename <span className="text-muted-foreground font-normal">(optional)</span></Label>
            <Input value={vals.report_filename} onChange={(e) => setVals({ ...vals, report_filename: e.target.value })} className="mt-1" placeholder="e.g. SYMIN_REM2026_237" data-testid="es-filename" /></div>
        </div>
        <DialogFooter><Button onClick={save} className="w-full" data-testid="es-save">Save settings</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
